import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IQuestionnaireProcessed {
  isQuestionnaireProcessed: boolean;
  setIsQuestionnaireProcessed: (value: boolean) => void;
  fromCollectSample: boolean;
  setFromCollectSample: (value: boolean) => void;
  confirmedDOBDate: string | null;
  setConfirmedDOBDate: (date: string | null) => void;
}

export const useQuestionnaireProcessed = create<IQuestionnaireProcessed>()(
  persist(
    (set) => ({
      isQuestionnaireProcessed: false,
      setIsQuestionnaireProcessed: (value) =>
        set({ isQuestionnaireProcessed: value }),
      fromCollectSample: false,
      setFromCollectSample: (value) => set({ fromCollectSample: value }),
      confirmedDOBDate: null,
      setConfirmedDOBDate: (date) => set({ confirmedDOBDate: date }),
    }),
    { name: 'questionnaire-processed' },
  ),
);
